<!-- *ngIf="flag==true" -->
<router-outlet *ngIf="flag==true || mvc.checkAuthenticByPass() || mvc.isAuthenticByPass"></router-outlet>
<!--Loaders start-->

    <div *ngIf="!flag && masterapi_exeution==true && !mvc.checkAuthenticByPass()" class='text-center mt-4'>
        <img src="assets/themes/images/img-video-loader.gif" width="40" height="40" id="loadmore_post">
    </div>
    <div class="container" *ngIf="!flag && masterapi_exeution==false && delay_time==true">
        <div class="row">
            <div class="col-lg-12 col-xs-12 col-sm-12 col-md-12">
                <div class="si-jounral-container clearfix">
                    <div class="si-jounralDtails-col">
                        <div id="jounralView" class="jounral-container">
                            <section class="jounral_404" style="background-image:url('./assets/images/404.png')">
                                <div class="text_center">

                                    <p><strong>{{mls?.languageText?.middle_ware?.key1}}<span *ngIf="mls?.is_lskey_display == 1">(middle_ware.key1)</span>
                                    </strong>
                                    {{mls?.languageText?.middle_ware?.key2}}<span *ngIf="mls?.is_lskey_display == 1">(middle_ware.key2)</span> </p>
                                    <a (click)="Reload_page()" class="go_btn">{{mls?.languageText?.middle_ware?.key3}}<span *ngIf="mls?.is_lskey_display == 1">(middle_ware.key3)</span> </a>
                                </div>
                            </section>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
<!-- <div class="container"  *ngIf="flag==false">
        <div class="row">
            <div class="col-md-4 col-lg-4">
                    <ngx-content-loading>
                            <svg:g ngx-instagram-preset></svg:g>
                        </ngx-content-loading>
            </div>
            <div class="col-md-8 col-lg-8">
                    <ngx-content-loading >
                            <svg:g ngx-facebook-preset></svg:g>
                    </ngx-content-loading>
                    <br>

                    <ngx-content-loading >
                            <svg:g ngx-list-preset></svg:g>
                    </ngx-content-loading>

                    <ngx-content-loading >
                            <svg:g ngx-facebook-preset></svg:g>
                    </ngx-content-loading>



                </div>



        </div>
  </div>   -->

<!--Loaders end-->

<!-- <app-error-modal *ngIf="isErrorModalShown==true" (resetErrorModal) = resetErrorModal($event)   [isErrorModalShown]=isErrorModalShown [error_msg]="error_msg"></app-error-modal> -->

<app-internet-connection-modal *ngIf="isConnectionModalShown==true" (resetConnectionModal)=resetConnectionModal($event)
    [isConnectionModalShown]=isConnectionModalShown>
</app-internet-connection-modal>

<app-web-modal *ngIf="displayObj?.isShow" [isShownWebModal]="displayObj?.isShow" [displayObj]="displayObj"
    (resetWebModal)=resetWebModal($event)></app-web-modal>
    <!-- stories module -->
    <app-story-creation *ngIf="create_user_story && (productImage || productData || storyRepostingFileCode || templateList)" (emitOnHidden)="resetStoryCreation()" [templateList]="templateList" [customTemplateType]="customTemplateType" [backGroundCode]="backGroundCode" (emitOnHidden)="resetStoryCreation($event)" [isCustomTemplate]="true" [productData]="productData" [repostingFileCode]="storyRepostingFileCode" [productImage]="productImage" [isStoryCreationMode] = "create_user_story" [productType]="UserStoryProductType"></app-story-creation>
   
    <app-nudges-modal *ngIf="(this.mls.featureOnOffList.featureList.userStory.value || !mls.userLoginFlow)" [isNudgeModal]="userStoryNudge" [storyNudgeType]="storyNudgeType" [submitButtonText]="userStoryNudgeButton" [nudgeIcon]="nudgeIcon" [headingText]="nudgeHeading" [paragraphText]="nudgeDiscription"
    (emitOnHidden)="hideNudge($event)" (emitOnSubmit)="createStoryThroughNudge($event)"></app-nudges-modal>
    <div *ngIf="viewStoryThroughProf" class="story-carousel">
        <span class="d-none d-md-block story-carousel-heading text-white">
          <h2 class="heading-2 text-white">{{mls.languageText.stories.key1}}</h2>
        </span>
        <!-- d-none d-sm-block -->
        <span class="story-carousel-cross d-none d-md-block" (click)="closeStories()">
          <img src="assets/images/story-cross.svg" alt="cross">
        </span>
        <div *ngIf="userStorySer.UserStoryDetail.get(userStorySer.currentStoryUuid) && userStorySer.storyLoadingState.get(userStorySer.currentStoryUuid); else storyFail" class="d-flex justify-content-center align-items-center w-100 h-100">
          <app-stories
            class="w-100"
            [stories]="userStorySer.UserStoryDetail.get(userStorySer.currentStoryUuid).value"
            [uuid]="userStorySer.currentStoryUuid"
            [autoStart]="true"
            [defaultStoryCode]="dss.currentStoryCode"
            [viewListByDefault]="dss.viewListByDefault"
            [currentPlaying]="true"
            (onAllStoriesEnd)="onAllStoriesEnd($event)"
            (onGoBack)="viewStoryThroughProf = false"
            (emitCtaTarget)="onCtaClick($event)"
            (onStoryChange)="onStoryChange($event)"
            (logViewStory)="logViewStory($event)"
            (emitClose)="closeStories()"
            [activeStoryIndex]="activeStoryIndex"
            (headerRedirect)="headerRedirection($event)"
            [loadingState]="userStorySer.storyLoadingState.get(userStorySer.currentStoryUuid)">
          </app-stories>
        </div>
          <ng-template #storyFail>
            <div  class="d-flex justify-content-center align-items-center w-100 h-100">
              <app-stories 
              [stories]="userStorySer.UserStoryDetail.get(userStorySer.currentStoryUuid)"
              [uuid]="userStorySer.currentStoryUuid"
              [autoStart]="true"
              [currentPlaying]="true"
              [activeStoryIndex]="activeStoryIndex"
              (onAllStoriesEnd)="onAllStoriesEnd($event)"
              (onGoBack)="isStoriesOpen = false"
              (onStoryChange)="onStoryChange($event)"
              (emitClose)="closeStories()"
              [loadingState]="userStorySer.storyLoadingState.get(userStorySer.currentStoryUuid)" class="w-100" [autoStart]="true" [currentPlaying]="true" (onAllStoriesEnd)="onAllStoriesEnd($event)"></app-stories>
            </div>
          </ng-template>
      </div>
<app-posting *ngIf="show_feed_post_modal==true" [show_feed_post_modal]="show_feed_post_modal"
    (resetFeedPostModal)="resetFeedPostModal($event)"></app-posting>

    <!-- profile nudges start here -->
    <app-profile-nudge *ngIf="toShowProfileNudge && this.isNudgeToBeBlackListed() && profile_nudge_data != null" [eventName]="profileNudgeEventName" (closeNudge)="closeProfileNudge()"   [profileData]="profile_nudge_data" (emitperformAction)="performAction($event)" (emitPerformAnalytics)="sendProfileAnalytics($event)"></app-profile-nudge>

<!-- skp popup start**************************** -->
<app-web-cme-vault-add-skp-points *ngIf="skpPointData?.isShow==true" [skpPointData]="skpPointData">
</app-web-cme-vault-add-skp-points>
<!-- skp popup end ***************************** -->

<!---feed detail modal-->
<app-feed-detail-modal *ngIf="feedDetailObj?.is_show==true" [feedDetailModal]="feedDetailObj?.is_show"
    (resetFeedDetailModal)="resetFeedDetailModal($event)" [mediaIdx]="feedDetailObj?.mediaIdx"
    [feedId]="feedDetailObj?.feed_id" [ecId]="feedDetailObj.ecId" [isPostedEvent]="feedDetailObj.isPostedEvent">
</app-feed-detail-modal>

<app-product-subscribe *ngIf="showSubscribeModal==true" [channelcardcalling]="channelcardcalling"
    (resetSubscribeModal)=resetSubscribeModal($event) (hasSubscribed)=hasSubscribed($event)
    [showSubscribeModal]=showSubscribeModal [channelData]="subscribe_obj" [detailId]="detailId"></app-product-subscribe>

<!-- <app-samvaad *ngIf="!isDetailPage"></app-samvaad> -->
<ng-template reusable-outlet-chat [reusableComponent]="reusableComponents.DQ_CHAT_PANEL" *ngIf="flag==true && dqChatPanelService.isChatPanelVisible"></ng-template>


<app-common-nudge *ngIf="mls.toShowNologinRestrictionPopUp === true" [headingText]="mls.languageText.no_login.key1" [paragraphText]="mls.languageText.no_login.key2" [submitButtonText]="mls.languageText.no_login.key3" [nudgeIcon]="'assets/images/webinar-nudge.png'" (emitOnHidden)="closeOpenAccessRestrictionNudge()"></app-common-nudge>